import { Injectable, OnDestroy, Optional } from '@angular/core';
import { DebugService } from '@services/debug.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InteractiveContentTranslateService implements OnDestroy {
  private showKeys = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(@Optional() private debugService?: DebugService) {
    if (debugService) {
      this.debugService
        .isShowLabelKeys$()
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe((flag) => (this.showKeys = flag));
    }
  }

  /**
   * Returns label value/its key for valid/invalid value accordingly.
   * Also, lets the returned value be key, if, debug service returns true for 'isShowLabelKeys'.
   * @param label translated label value from json
   * @param labelAsString stringified translated label
   */
  instant(label: string, labelAsString: string): string {
    if (label && !this.showKeys) {
      return label;
    }

    return `[${labelAsString}]`;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
